import * as React from "react"
import WalmartSearchBoost from "../../svgs/components/minimalist-pages/walmart-search-boost"
import ContentTrends from "../../svgs/components/minimalist-pages/content-trends"
import RichMedia from "../../svgs/components/minimalist-pages/unlimited-rich-media"

const DiagnoseAndFixTools = (props) => (
    <div id="diagnose-and-fix-carousel" className="carousel slide carousel-fade w-100" data-bs-ride="carousel">
        <div className="carousel-inner w-100">
            <div className="carousel-item active  w-100 d-flex justify-content-center">
                <WalmartSearchBoost className='w-80 tool-abstraction'/>
            </div>
            <div className="carousel-item  w-100 d-flex justify-content-center">
                <ContentTrends className='w-80 tool-abstraction'/>
            </div>
            <div className="carousel-item  w-100 d-flex justify-content-center">
                <RichMedia className='w-80 tool-abstraction'/>
            </div>
        </div>
    </div>
)

export default DiagnoseAndFixTools;
